import Swiper, {Autoplay, Navigation} from 'swiper';

(function ($) {
    $(document).ready(function () {

        const $block = $('.wp-block-group.swiper');
        const $blockContainer = $block.find('> div.wp-block-group__inner-container');
        $blockContainer.wrapInner(`<div class="swiper-container-block"><div class="swiper-wrapper"></div></div>`);

        const $swiperSlides = $blockContainer.find('div.swiper-wrapper > div');
        $swiperSlides.wrap(`<div class="swiper-slide"></div>`);

        $('.wp-block-group.swiper.with-navigation .swiper-container-block').append(`
            <div class="swiper-controls">
                <div class="swiper-prev">
                    <i data-feather="arrow-left"></i>
                </div>
                <div class="swiper-next">
                    <i data-feather="arrow-right"></i>
                </div>
            </div>`);

        Swiper.use([Autoplay, Navigation]);

        $('.swiper-container-block').each(function (index, element) {
            const $this = $(this);
            const slidePerView = $this.parents('.swiper').hasClass('2-slides-per-view') ? 2 : 1;
            new Swiper(element, {
                loop: true,
                slidesPerView: slidePerView,
                autoplay: {
                    delay: 3000
                },
                navigation: {
                    nextEl: $this.find('.swiper-next')[0],
                    prevEl: $this.find('.swiper-prev')[0]
                }
            });
        });

        feather.replace();

    });
})(jQuery);
